import React, { useState } from "react";
import { useParams } from "react-router-dom";
import UploadContractor from "./UploadContractor";
import UploadEditor from "./UploadEditor";
import UploadAdmin from "./UploadAdmin";

const TabButton = ({ isActive, onClick, children }) => (
  <button
    onClick={onClick}
    className={`px-6 py-3 font-medium text-sm ${
      isActive
        ? "text-black border-b-2 border-black"
        : "text-gray-500 hover:text-black"
    }`}
  >
    {children}
  </button>
);

const UploadMarketing = () => {
  const { propertyId, eventId } = useParams();
  // A job route is a contractor deep-link, so it must not land on the Editor
  // tab the way a bare /edits/:propertyId does.
  const [activeTab, setActiveTab] = useState(
    eventId ? "contractor" : propertyId ? "editor" : "contractor"
  );

  return (
    <div className="w-full container p-0 mx-auto">
      <div className="flex">
        <TabButton
          isActive={activeTab === "contractor"}
          onClick={() => setActiveTab("contractor")}
        >
          Contractor
        </TabButton>
        <TabButton
          isActive={activeTab === "editor"}
          onClick={() => setActiveTab("editor")}
        >
          Editor
        </TabButton>
        <TabButton
          isActive={activeTab === "admin"}
          onClick={() => setActiveTab("admin")}
        >
          Admin Extras
        </TabButton>
      </div>

      <div className="mt-2">
        {activeTab === "contractor" && <UploadContractor />}
        {activeTab === "editor" && <UploadEditor />}
        {activeTab === "admin" && <UploadAdmin />}
      </div>
    </div>
  );
};

export default UploadMarketing;
